// import type { ComponentData } from '@ui/cms/contracts';
// TODO: Create proper separation of UI types
type ComponentData = any; // Temporary fix to avoid UI dependency
import { DeviceType } from '.';

export enum DragItemType {
  Row = 'ROW',
  Component = 'COMPONENT',
}

export enum DropItemType {
  Row = 'ROW',
  Column = 'COLUMN',
}

export type DragItem = {
  id: string;
  type: DragItemType;
  index: number;
};

export type Layout = Pick<LayoutState, 'rootChildren' | 'rows' | 'columns' | 'components'>;

export interface LayoutState {
  rootChildren: string[];
  rows: Record<string, Row>;
  columns: Record<string, Column>;
  components: Record<string, Component>;
  focusedElement: string | null;
  componentSelector: {
    columnId: string;
  } | null;
  editComponentDialog: string | null;
  previewPage: boolean;
  layoutType: DeviceType;
}

export interface GradientStop {
  color: string;
  position: number; // 0-100 percentage
}

export type GradientType = 'linear' | 'radial';

export interface GradientConfig {
  type: GradientType;
  angle?: number; // For linear gradients (0-360 degrees)
  stops: GradientStop[];
}

export type BackgroundImageSource = 'url' | 'gallery' | 'upload';

export interface LayoutElementStyle {
  backgroundColor?: string;
  backgroundImage?: string;
  backgroundImageSource?: BackgroundImageSource;
  backgroundSize?: 'cover' | 'contain' | 'auto';
  backgroundPosition?: string;
  backgroundRepeat?: 'no-repeat' | 'repeat' | 'repeat-x' | 'repeat-y';
  gradient?: GradientConfig;
  height?: string; // CSS height value (e.g., '300px', '50vh')
  maxHeight?: string; // CSS max-height value (e.g., '500px', '80vh')
}

export interface Row {
  id: string;
  parentColumnId: string | null;
  columnIds: string[];
  style?: LayoutElementStyle;
}

export enum ColumnAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export enum ColumnDirection {
  Bottom = 'bottom',
  Right = 'right',
}

export interface Column {
  id: string;
  parentRowId: string;
  size: number;
  childrenIds: string[];
  alignment?: ColumnAlignment;
  direction?: ColumnDirection;
  style?: LayoutElementStyle;
  fitToSiblings?: boolean; // When true, column matches sibling height instead of expanding the row
}

export type Component = ComponentData & {
  parentColumnId: string;
};

export type CmsPage = {
  id: string;
  name: string;
  slug: string;
  desktopLayout?: Layout;
  tabletLayout?: Layout;
  mobileLayout?: Layout;
  meta?: {
    title?: string;
    description?: string;
    image?: string;
  };
};
